/**
 * RAOC-22 PR-2 — Internal helper for `useRovoConfig`.
 * Not exported via a package subpath.
 */

import { type FireAnalyticsEvent } from '../../common/utils/analytics/types';

type FailedDependency = 'combined-config' | 'combined-config-ssr' | 'outbound-auth-github';

type onFailedDependencyArgs = {
	dependency: FailedDependency;
	searchSessionId: string;
	source: string;
	moreContext?: Record<string, unknown>;
};

// Fires an event when a dependency fails outside any request caching.
// Note: should be fired at the application level, so this event matches
// impact on the UX.
export const onFailedDependency = ({
	dependency,
	searchSessionId,
	source,
	moreContext,
}: onFailedDependencyArgs): FireAnalyticsEvent => {
	return {
		source,
		action: 'failedDependency',
		actionSubject: 'rovoConnectorsConfig',
		eventType: 'track',
		attributes: {
			additionalAttributes: {
				failedDependency: dependency,
				searchSessionId,
				...(moreContext || {}),
			},
		},
	};
};
